import { demoOrders, panelModes } from "@/mocks/panelContent";
import { formatBRL } from "@/lib/format";
import { FieldRow, PanelBadge, PanelCard, ReadOnlyNotice } from "../components/PanelUI";

export default function OrdersSection() {
  const totals = demoOrders.reduce(
    (acc, order) => ({
      subtotal: acc.subtotal + order.subtotal,
      total: acc.total + order.total,
      items: acc.items + order.items.reduce((sum, item) => sum + item.quantity, 0),
    }),
    { subtotal: 0, total: 0, items: 0 },
  );

  return (
    <div className="flex flex-col gap-6">
      <ReadOnlyNotice text={panelModes.viewNotice} />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <div className="rounded-lg border border-background-200 bg-background-50 p-4">
          <p className="text-[11px] uppercase tracking-[0.14em] text-foreground-500">Pedidos demonstrativos</p>
          <p className="mt-1 font-heading text-2xl text-foreground-900">{demoOrders.length}</p>
        </div>
        <div className="rounded-lg border border-background-200 bg-background-50 p-4">
          <p className="text-[11px] uppercase tracking-[0.14em] text-foreground-500">Peças nos pedidos</p>
          <p className="mt-1 font-heading text-2xl text-foreground-900">{totals.items}</p>
        </div>
        <div className="rounded-lg border border-background-200 bg-background-50 p-4">
          <p className="text-[11px] uppercase tracking-[0.14em] text-foreground-500">Total somado</p>
          <p className="mt-1 font-heading text-2xl text-foreground-900">{formatBRL(totals.total)}</p>
        </div>
      </div>

      <PanelCard
        title="Pedidos"
        description="Cada confirmação cria um pedido com código próprio, nunca reutilizado."
      >
        <div className="flex flex-col gap-5">
          {demoOrders.map((order) => (
            <article key={order.code} className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-xl text-foreground-900">{order.code}</h3>
                  <PanelBadge tone="secondary">
                    {order.date} · {order.time}
                  </PanelBadge>
                </div>
                <PanelBadge tone="primary">{order.status}</PanelBadge>
              </div>

              <div className="mt-4 grid grid-cols-1 gap-x-8 lg:grid-cols-2">
                <div className="rounded-md border border-background-200 bg-background-100 px-3 py-1">
                  <FieldRow label="Cliente" value={order.customerName} />
                  <FieldRow label="WhatsApp" value={order.customerPhone} />
                  <FieldRow label="Modalidade" value={order.delivery} />
                  <FieldRow label="Endereço" value={order.address} />
                </div>
                <div className="rounded-md border border-background-200 bg-background-100 px-3 py-1">
                  <FieldRow label="Subtotal" value={formatBRL(order.subtotal)} />
                  <FieldRow label="Desconto" value={order.discount > 0 ? `-${formatBRL(order.discount)}` : formatBRL(0)} />
                  <FieldRow label="Entrega" value={order.shipping > 0 ? formatBRL(order.shipping) : "Grátis"} />
                  <FieldRow
                    label="Total estimado"
                    value={<span className="font-medium text-primary-700">{formatBRL(order.total)}</span>}
                  />
                </div>
              </div>

              <div className="mt-4">
                <p className="mb-2 text-[11px] uppercase tracking-[0.14em] text-foreground-500">Itens</p>
                <div className="flex flex-col gap-2">
                  {order.items.map((item) => (
                    <div
                      key={`${order.code}-${item.code}-${item.size}`}
                      className="flex flex-wrap items-center justify-between gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2"
                    >
                      <span className="text-sm text-foreground-800">{item.name}</span>
                      <span className="text-xs text-foreground-500">
                        {item.code} · {item.color} · Tam. {item.size} · {item.quantity}x
                      </span>
                      <span className="whitespace-nowrap text-sm text-foreground-700">
                        {formatBRL(item.unitPrice * item.quantity)}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mt-4 flex flex-wrap gap-2">
                <PanelBadge tone="neutral">Pagamento: {order.paymentStatus}</PanelBadge>
                <PanelBadge tone="neutral">Entrega: {order.deliveryStatus}</PanelBadge>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-4 text-[11px] leading-relaxed text-foreground-500">
          Status disponíveis: pedido iniciado, disponibilidade confirmada, aguardando pagamento, pago,
          em separação, enviado, pronto para retirada, entregue e cancelado.
        </p>
      </PanelCard>
    </div>
  );
}